define('Store.SearchSpring.EntryPoint', [
    'Profile.Model',
    'underscore',
    'Utils'
], function StoresSearchSpringEntryPoint(
    ProfileModel,
    _,
    Utils
) {
    'use strict';

    window.searchspringMappers = window.searchspringMappers || [];

    return {
        mountToApp: function mountToApp(container) {
            window.searchspringMappers.push(function mapPrices(data) {
                var profile = ProfileModel.getInstance();
                var store = profile.get('store');
                var ssOnlinePriceLevel = store.get('onlinePriceLevelSSKey');
                var mrspPriceLevel = store.get('msrpPriceLevelSSKey');
                var storeQuantityField = store.get('quantityAvailableSSField');
                var storeMainLocation = parseInt(store.get('mainLocation'), 10);
                var config = container.getConfig();
                var pricelevel = profile.get('priceLevel');
                // var defaultPricelevel = store.get('onlinePriceLevel') || SC.ENVIRONMENT.siteSettings.defaultpricelevel;
                var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;
                var storePrice = store.get('onlinePriceLevel');
                var customerPrice;
                var isPackItem = data.saleunit !== 'Unit';
                var priceLevelMapping = config.get('searchspring.priceLevelMapping') || [];
                var oldMrspPriceLevel = mrspPriceLevel;
                var storeWithPriceLevel;

                if (isPackItem) {
                    mrspPriceLevel = mrspPriceLevel.replace('_0', '_1');
                }

                // PRICING Maps
                data['pricelevel' + store.get('onlinePriceLevel')] = data[ssOnlinePriceLevel];
                data['pricelevel' + store.get('onlinePriceLevel') + '_formatted'] = Utils.formatCurrency(data[ssOnlinePriceLevel]);
                data['pricelevel' + store.get('msrpPriceLevel')] = data[mrspPriceLevel] || data[oldMrspPriceLevel];
                data['pricelevel' + store.get('msrpPriceLevel') + '_formatted'] = (data[mrspPriceLevel] && Utils.formatCurrency(data[mrspPriceLevel])) ||
                    (data[oldMrspPriceLevel] && Utils.formatCurrency(data[oldMrspPriceLevel]));

                if (store.get('priceField')) {
                    data[store.get('priceField').toLowerCase() + '_formatted'] = Utils.formatCurrency(data[store.get('priceField').toLowerCase()]);
                }

                if (pricelevel !== defaultPricelevel) {
                    customerPrice = priceLevelMapping && priceLevelMapping.length && _.findWhere(priceLevelMapping, {netsuiteid: pricelevel + ''});
                    if (customerPrice && customerPrice.searchspringid && data[customerPrice.searchspringid]) {
                        data.onlinecustomerprice_detail = {
                            onlinecustomerprice: data[customerPrice.searchspringid],
                            onlinecustomerprice_formatted: Utils.formatCurrency(data[customerPrice.searchspringid])
                        };
                    } else {
                        storeWithPriceLevel = SC.ENVIRONMENT.published.stores && _.findWhere(SC.ENVIRONMENT.published.stores, { onlinePriceLevel: pricelevel });
                        if (storeWithPriceLevel && storeWithPriceLevel.priceField &&
                            data[storeWithPriceLevel.priceField.toLowerCase()]) {
                            data.onlinecustomerprice_detail = {
                                onlinecustomerprice: data[storeWithPriceLevel.priceField.toLowerCase()],
                                onlinecustomerprice_formatted: Utils.formatCurrency(data[storeWithPriceLevel.priceField.toLowerCase()])
                            };
                        } else {
                            customerPrice = priceLevelMapping && priceLevelMapping.length && _.findWhere(priceLevelMapping, {netsuiteid: pricelevel + ''});
                            if (customerPrice && customerPrice.searchspringid && data[customerPrice.searchspringid]) {
                                data.onlinecustomerprice_detail = {
                                    onlinecustomerprice: data[customerPrice.searchspringid],
                                    onlinecustomerprice_formatted: Utils.formatCurrency(data[customerPrice.searchspringid])
                                };
                                if (isPackItem) {
                                    customerPrice = _.extend({}, customerPrice);
                                    customerPrice.searchspringid = customerPrice.searchspringid.replace('_0', '_1');
                                    if (data[customerPrice.searchspringid]) {
                                        data.onlinecustomerprice_detail = {
                                            onlinecustomerprice: data[customerPrice.searchspringid],
                                            onlinecustomerprice_formatted: Utils.formatCurrency(data[customerPrice.searchspringid])
                                        };
                                    }
                                }
                            }
                        }
                    }

                }

                data.isSearchSpring = true;

                data.quantityavailable_detail = {
                    quantityavailable: parseInt(data[storeQuantityField], 10) || 0,
                    locations: [
                        {
                            internalid: storeMainLocation,
                            quantityavailable: parseInt(data[storeQuantityField], 10)
                        }
                    ]
                };
            });
        }
    };
});
